export default __webpack_public_path__ + "static/media/OTHER_CULTURE.9fc3b3dd.svg";